module.exports = __webpack_public_path__ + "img/selected_regular_in_installation.49249890.svg";